/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { donationTypeEnumSchema } from "./donationTypeEnumSchema.ts";
import { z } from "zod";

export const donationModelSchema = z.object({
    "userId": z.string().uuid().describe("Идентификатор пользователя").nullable().nullish(),
"nickname": z.string().describe("Пользователь").nullable().nullish(),
"amount": z.number().int().describe("Сумма платежа в копейках"),
"date": z.string().datetime({ offset: true }).describe("Дата платежа"),
"type": z.lazy(() => donationTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Donate</b>: Пожертвование</li>\n</ul>\n")
    })